function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { Component } from 'react';
import ButtonBase from '@material-ui/core/ButtonBase';
import Typography from '@material-ui/core/Typography';
import OwnerIcon from "../Owner/OwnerIcon";
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
    listStyle: "none",
    padding: 0,
    margin: 0,
    display: "flex",
    alignItems: "center",
    justifyContent: "left",
    padding: theme.spacing(1.25)
  },
  icon: {
    position: "relative",
    width: "36px",
    height: "36px"
  },
  label: {
    fontSize: "14px",
    fontWeight: "bold",
    margin: theme.spacing(1)
  }
}));

const OwnersListItem = (_ref) => {
  let title = _ref.title,
      onClick = _ref.onClick,
      props = _objectWithoutPropertiesLoose(_ref, ["title", "onClick"]);

  const classes = useStyles();
  return React.createElement(ButtonBase, {
    className: classes.root,
    onClick: onClick
  }, React.createElement(OwnerIcon, _extends({
    className: classes.icon
  }, props, {
    title: title
  })), React.createElement(Typography, {
    className: classes.label,
    noWrap: true
  }, title));
};

export default OwnersListItem;